import { GetterTree } from 'vuex';
import { State } from './state';

export function createGetters(): GetterTree<State, State> {
  return {};
}
